import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
// Redux Imports
import { useSelector, useDispatch } from 'react-redux';
import { fetchPost } from '../../../../api/fetch';
import { openSnackBar } from '../../../../actions/snackbarAction';
import { logOut } from '../../../../actions/loginActions';
// Style Imports
import './styles.scss';
//Images
import Logo from '../../../../assets/logo.svg';

export default function ExamSolutions(props) {
  let { testID } = useParams();
  // State
  const [testData, setTestData] = useState({});
  // Reducers
  const dispatch = useDispatch();
  const jwtToken = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );

  useEffect(() => {
    getSolutions();
  }, []);

  const getSolutions = async () => {
    let id = testID;
    if (!id) id = props.TPCID;
    const body = {
      TPCID: id.replace('&frasl;', '/')
    };
    const url = 'api/exam/viewsolution';
    await fetchPost(url, body, jwtToken)
      .then(res => {
        return res.json();
      })
      .then(async data => {
        if (data.error && !Object.keys(data).includes('data')) {
          return dispatch(
            openSnackBar({
              message: 'Some error occurred',
              severity: 'error'
            })
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning'
            })
          );
          return dispatch(logOut());
        }
        await setTestData(data);
      });
  };

  useEffect(() => {
    setTimeout(function() {
      if (!isEmpty(testData) && testID) window.print();
    }, 1000);
  }, [testData]);

  return (
    <div className="flex-column align-center user-exam-solutions">
      <div className="logo">
        <img src={Logo} alt="logo" />
        <div style={{ position: 'absolute', right: 0 }}>
          {!testID && props.TPCID ? (
            <Link to={`/exam-hall/${props.TPCID.replace('/', '&frasl;')}`}>
              <Button
                variant="contained"
                color="primary"
                style={{ width: '40%', alignSelf: 'flex-end' }}
              >
                Print
              </Button>
            </Link>
          ) : null}
        </div>
      </div>

      <h1 className="test-title">
        Question Paper of {get(testData, 'data.TestTitle', '')} /
        {get(testData, 'data.TestDate', '')}
      </h1>
      <div id="section-to-print" className="questions-container">
        <h3 className="paper-no">Paper No: STLA</h3>
        {get(testData, 'data.listQuestion', []).map((data, i) => {
          return (
            <div className="flex-column" key={i}>
              <div className="question">Question No - {data.QuestionNo}</div>
              <div className="image">
                <img src={data.QuestionImage} />
              </div>
              <div className="answer"> Answer : {data.Answer} </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ExamSolutions.propTypes = {
  TPCID: PropTypes.string
};
